import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=31581cea&scoped=true"
import script from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=31581cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31581cea",
  null
  
)

export default component.exports